export default __webpack_public_path__ + "static/media/circel.a38d2052.webp";